import React, { useContext } from 'react';

import { AppContext } from '@prisjakt/ui-app-context';

import Rating from 'src/components/rating';
import RatingHelper from 'src/components/rating/rating-helper';
import RatingIcon from 'src/components/rating/smiley-rating/rating-icon';

import * as S from './styles';

import { RatingString } from 'src/components/rating/smiley-rating/types';

import { getSmileyRating } from 'src/components/rating/smiley-rating/utils';
import { useViewportContext } from '../../../viewport/context';

type Props = {
  type: 'store' | 'product';
  rating: number;
  numericRating?: boolean;
  disabled?: boolean;
};

const ReviewRating = ({
  type,
  rating,
  numericRating,
  disabled = false,
}: Props) => {
  const { isMobile } = useViewportContext();
  const { t } = useContext(AppContext);

  if (type === 'store') {
    const rate = RatingHelper.convert(rating, 1);
    const smileyRating = getSmileyRating(rate.real);
    const ratingType = numericRating
      ? rate.rounded
      : t('reviews', smileyRating?.text as RatingString);

    return smileyRating?.iconType && smileyRating?.text ? (
      <>
        <RatingIcon
          type={smileyRating.iconType}
          disabled={disabled}
          ariaLabel={ratingType.toString()}
        />
        {isMobile && numericRating ? null : <S.Text>{ratingType}</S.Text>}
      </>
    ) : null;
  }

  return <Rating rate={rating} />;
};

export default ReviewRating;
